// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__25ze0","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2xPDV","obliqueLine":"membershipbadge_obliqueLine__3YGLO"};